import script from "./SpecificFunctionalities.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecificFunctionalities.vue?vue&type=script&setup=true&lang=js"

import "./SpecificFunctionalities.vue?vue&type=style&index=0&id=4079b72e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4079b72e"]])

export default __exports__